import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { map, tap } from 'rxjs';
import { Router } from '@angular/router';
import {
  LoginResponse,
  RefreshResponse,
  ForgetPasswordResponse,
  ResetPasswordResponse,
} from '../../../shared/interfaces/auth.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  initiateLogin(email: string, password: string) {
    return this.http
      .post<LoginResponse>(environment.apiUrl, {
        data: { userEmail: email, password },
      })
      .pipe(
        map((response) => response.data),
        tap((creds) => {
          localStorage.setItem(
            environment.refreshToken,
            JSON.stringify(creds.sRefreshToken),
          );
        }),
      );
  }
  generateAccessToken(sRefreshToken: string) {
    return this.http
      .post<RefreshResponse>(`${environment.apiUrl}/refresh`, {
        data: { sRefreshToken },
      })
      .pipe(map((response) => response.data));
  }

  initiateLogout(url: string | null) {
    localStorage.removeItem(environment.refreshToken);
    void this.router.navigateByUrl(url ? `/?redirect-url=${url}` : '/');
  }

  forgotPassword(email: string, redirectUrl?: string) {
    return this.http
      .post<ForgetPasswordResponse>(`${environment.apiUrl}/forget-password`, {
        email,
        redirectUrl,
      })
      .pipe(map((response) => response.data));
  }

  resetPassword(token: string, newPassword: string, confirmPassword: string) {
    return this.http
      .post<ResetPasswordResponse>(`${environment.apiUrl}/reset-password`, {
        token,
        newPassword,
        confirmPassword,
      })
      .pipe(map((response) => response.data));
  }
}
